import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { catalogBibShape, ugcQuotationShape, libraryShape } from '@bibliocommons/bc-prop-types';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBibEntities, selectQuotationEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import RelationshipsActions from 'app/actions/RelationshipsActions';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import QuotationPage from './QuotationPage';

export function QuotationPageContainer(props) {
  const { catalogBib, quotation, intl } = props;
  if (!quotation) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />;
  }

  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'quotation_page_title' }, { title });

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <QuotationPage {...props} />
    </div>
  );
}

QuotationPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotation: ugcQuotationShape,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => {
  const quotation = state.getIn(['ugc', 'quotation']);
  const quotationEntity = selectQuotationEntities(state).get(quotation.get('id', '').toString());
  if (!quotationEntity) return {};

  return {
    catalogBib: selectCatalogBibEntities(state).get(quotationEntity.get('metadataId')),
    currentUserId: selectCurrentUser(state)?.get('id') ?? null,
    currentLibrary: selectCurrentLibrary(state),
    quotation: quotationEntity
  };
};

const mapDispatchToProps = dispatch => ({
  relationshipsActions: bindActionCreators(RelationshipsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(QuotationPageContainer));
